module.exports = __webpack_public_path__ + "static/media/bg3.55c8b3b7.png";